import { appInfo } from "../common/data/appinfo";
export default[

    // spreadsheet
  {
    path: "/oIcQNJ5OZubAoqhdaq6xD7lt",
    children: [
      {
        path: "wjcK3lQRjrd6oIcQNJ5OZubAA",
        name: "subject-spreadsheet",
        meta: {
          title:
            appInfo?.type === "codsms"
              ? "Subject Spreadsheet"
              : "Course Spreadsheet",
          authRequired: true,
          acc: ["y60938"],
        },
        component: () => import("@/views/spreadsheet/subject/index.vue"),
      },
      {
        path: "wjcK3lQRjrd6oIcQNJ5OZubAAGWWE",
        name: "arm-spreadsheet",
        meta: {
          title:"Subject Spreadsheet",
          authRequired: true,
          acc: ["y60938"],
        },
        component: () => import("@/views/spreadsheet/subject/index-subject.vue"),
      },
      {
        path: "oIcQNJ5OZAoqhdaq6xD7lt/:frt?",
        name: "class-spreadsheet",
        meta: {
          title:
            appInfo?.type === "codsms"
              ? "Arm Spreadsheet"
              : "Level Spreadsheet",
          authRequired: true,
          acc: null,
        },
        component: () => import("@/views/spreadsheet/class/index.vue"),
      },
    ],
  },
]